@if(tipoSucesso){
    <a ngbNavLink class="nav-link mb-3" style="border-color: #2ab57d !important;">
        <div class="d-flex align-items-center">
            <i class="bx bx-check-double h3 mb-0 me-4" style="color: #2ab57d !important;"></i>
            <div class="flex-1">
                <h2>{{ titulo }} <span class="text-muted font-size-15" style="color: #2ab57d !important;"></span>
                </h2>
                <p class="fw-normal mb-0 text-muted text-s">{{ descricao }}</p>
            </div>
        </div>
    </a>
}@else {

    <a ngbNavLink class="nav-link mb-3">
        <div class="d-flex align-items-center">
            <i class="bx bx-check-circle h3 mb-0 me-4"></i>
            <div class="flex-1">
                <h2 class="fw-medium">{{ titulo }} <span class="text-muted font-size-15"></span>
                </h2>
                <p class="fw-normal mb-0 text-muted">{{ descricao }}</p>
            </div>
        </div>
    </a>
}